<template>
  <el-dialog
    title="修改店铺"
    :visible.sync="visible"
    width="520px"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="店铺名称" prop="shopName">
        <el-input v-model="form.shopName" maxlength="200" clearable />
      </el-form-item>

      <el-form-item label="服务费规则" prop="ssrId">
        <el-select
          v-model="form.ssrId"
          placeholder="请选择服务费"
          filterable
          style="width: 100%"
          :loading="loadingRules"
        >
          <el-option
            v-for="item in serviceRules"
            :key="item.ssrId"
            :label="formatRuleLabel(item)"
            :value="item.ssrId"
          />
        </el-select>
        <div class="tips" v-if="!form.shopType">
          未获取到店铺类型，无法加载服务费规则
        </div>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateShop as adminUpdateShop } from '@/api/admin/merchantShopApi'
import { queryShopServiceRule } from '@/api/shop/shopServiceRuleApi'

export default {
  name: 'AdminUpdateShop',
  data() {
    return {
      visible: false,
      saving: false,
      loadingRules: false,
      serviceRules: [],
      form: {
        shopId: '',
        shopName: '',
        shopType: '',
        ssrId: ''
      },
      rules: {
        shopName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
          { max: 200, message: '店铺名称不能超过200个字符', trigger: 'blur' }
        ],
        ssrId: [{ required: true, message: '请选择服务费规则', trigger: 'change' }]
      }
    }
  },
  methods: {
    open(shop) {
      this.visible = true
      this.serviceRules = []
      this.form.shopId = shop.shopId
      this.form.shopName = shop.shopName
      // aShop 列表返回字段通常包含 shopType / ssrId（后端 mapper 已 select ssr_id as ssrId）
      this.form.shopType = shop.shopType || ''
      this.form.ssrId = shop.ssrId || ''

      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })

      this.loadRules()
    },
    close() {
      this.visible = false
    },
    async loadRules() {
      if (!this.form.shopType) {
        return
      }
      this.loadingRules = true
      try {
        const res = await queryShopServiceRule({
          page: 1,
          row: 100,
          shopTypeId: this.form.shopType
        })
        this.serviceRules = (res && res.data) || []
        if (!this.form.ssrId && this.serviceRules.length > 0) {
          this.form.ssrId = this.serviceRules[0].ssrId
        }
      } finally {
        this.loadingRules = false
      }
    },
    formatRuleLabel(rule) {
      const serviceFee = this.formatPercent(rule.serviceFee)
      const communityFee = this.formatPercent(rule.communityFee)
      const profitFee = this.formatPercent(rule.profitFee)
      const typeName = rule.typeName || '服务费'
      return `${typeName}：服务费 ${serviceFee}%（物业 ${communityFee}%，平台 ${profitFee}%）`
    },
    formatPercent(val) {
      if (val === null || val === undefined || String(val).trim() === '') {
        return '0.0000'
      }
      const n = Number(val)
      if (Number.isNaN(n)) {
        return String(val)
      }
      return n.toFixed(4)
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        this.saving = true
        try {
          await adminUpdateShop({
            shopId: this.form.shopId,
            shopName: this.form.shopName,
            ssrId: this.form.ssrId
          })
          this.$message.success('修改成功')
          this.visible = false
          this.$emit('refresh')
        } catch (e) {
          this.$message.error(e && e.message ? e.message : '修改失败')
        } finally {
          this.saving = false
        }
      })
    }
  }
}
</script>

<style scoped>
.tips {
  margin-top: 6px;
  color: #999;
  font-size: 12px;
}
</style>

